export const COMMANDS = 'COMMANDS'
export const COMMANDS_STATUS = 'COMMANDS_STATUS'
export const ADD_COMMANDS = 'ADD_COMMANDS'
export const ADD_COMMANDS_STATUS = 'ADD_COMMANDS_STATUS'
export const UPDATE_COMMANDS = 'UPDATE_COMMANDS'
export const UPDATE_COMMANDS_STATUS = 'UPDATE_COMMANDS_STATUS'
